import {mapActions, mapGetters} from 'vuex';

export default {
  computed: {
    ...mapGetters({
      storeGetBranch: 'getBranch',
      storeGetService: 'getService',
      storeGetDate: 'getDate',
      storeGetQueue: 'getQueue',
      storeGetPhone: 'getPhone',
    })
  },
  methods: {
    ...mapActions({
      storeSetBranch: 'setBranch',
      storeSetService: 'setService',
      storeSetDate: 'setDate',
      storeSetQueue: 'setQueue',
      storeSetPhone: 'setPhone',
    }),
    getLocale() {
      return this.$route.params.locale ? this.$route.params.locale : null;
    },
    getBranch() {
      return this.$route.params.branch ? this.$route.params.branch : null;
    },

    getService() {
      return this.$route.params.service ? this.$route.params.service : null;
    },

    getDate() {
      return this.$route.params.date ? this.$route.params.date : null;
    },
  },
};
